export default "__VITE_ASSET__BJl7Yz4S__"